// src/components/AdminSidebar.js
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./AdminSidebar.css";
import knowledgeLogo from "./../../ms-knowledge-logo (1).svg"; // Adjust path if needed
import { useSelector } from "react-redux";

const AdminSidebar = () => {
  const location = useLocation(); // Get current location
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  // Determine if the current path matches the AdminSettings route
  const isApiActive = location.pathname === "/admin-settings";

  const redirectToHomePage = () => {
    navigate("/knowledge");
  };

  return (
    <div className="admin-sidebar">
      <div className="logo-container">
        <img
          onClick={() => redirectToHomePage()}
          src={knowledgeLogo}
          alt="Knowledge"
          className="logo"
        />
      </div>
      <nav className="nav-links">
        <Link
          to="/"
          className={location.pathname === "/dashboard" ? "active" : ""}
        >
          Dashboard
        </Link>
        <Link to="/admin-settings" className={isApiActive ? "active" : ""}>
          API
        </Link>
        {user?.userRole === "superuser" && (
          <Link
            to="/export-domain"
            className={location.pathname === "/export-domain" ? "active" : ""}
          >
            Export/Domain
          </Link>
        )}
      </nav>
    </div>
  );
};

export default AdminSidebar;
